var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAwardOutlineIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.75l-2.31-9C17.544 10.687 18.007 9.363 18 8c0-3.314-2.686-6-6-6S6 4.686 6 8c-.003 1.374.47 2.706 1.34 3.77L5 20.75c-.139.535.182 1.08.717 1.219.259.067.533.028.763-.109l5.33-3.13 5.68 3.14c.153.093.33.138.51.13.552.018 1.014-.416 1.031-.968.003-.095-.007-.19-.031-.282zM12 4c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm.31 12.71c-.31-.179-.69-.179-1 0l-3.75 2.2L9 13.21c1.833 1.053 4.087 1.053 5.92 0L16.45 19l-4.14-2.29z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAwardOutlineIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/awardOutlineIcon.e8825b8d.svg";
export { ForwardRef as ReactComponent };